export default "__VITE_ASSET__Cp53y7lj__"